import React from "react";
import { Input } from "@/components/ui/input";
import { StepCard, Field, CATEGORY_LABEL_OPTIONS } from "./_helpers";

/** Step 2 — what to call categories (Subjects / Learning Areas / Competencies / Custom). */
export default function Step2CategoryLabel({ categorySettings, onChange }) {
  return (
    <StepCard step="Step 2" title="Grade Category Label"
      subtitle={`This label replaces "Subject" throughout Grading Setup, Grades, and Print.`}
      testId="step-2"
    >
      <Field label="LABEL">
        <select value={categorySettings.category_label}
          onChange={(e) => onChange({ category_label: e.target.value })}
          className="gs-select" data-testid="gs-cat-label">
          {CATEGORY_LABEL_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </Field>
      {categorySettings.category_label === "custom" && (
        <Field label="CUSTOM LABEL" className="mt-3">
          <Input value={categorySettings.custom_label || ""}
            onChange={(e) => onChange({ custom_label: e.target.value })}
            placeholder="e.g. Learning Strands" className="rounded-xl h-11" data-testid="gs-custom-label" />
        </Field>
      )}
    </StepCard>
  );
}
